import React, { useEffect, useState } from "react";
import Layout from "~/components/Layout";
import themes from "~/themes";
import * as S from "./styles";
import { useLocation, useHistory } from "react-router-dom";
import { moneyMask, convertISODateMode3 } from "~/utils/mask";
import { MdShoppingBag, MdAttachMoney, MdMoneyOff } from "react-icons/md";
import { Content, Title, Header } from "../../styles";

const DetailingInvoice = () => {
    const history = useHistory();
    const { state } = useLocation();
    const data = state?.data;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);

        const el = document.querySelector("#root");
        if (el) el.scrollTo(0, 0);
    }, []);

    if (!data) return null;

    const getIconConfig = (item) => {
        const tipo = item.tipo;
        const isCredit = item.debitoCredito === "CREDITO";
        const isPayment =
            tipo === "PAGAMENTO" ||
            tipo === "PAGAMENTO_FATURA" ||
            tipo === "CASHBACK";

        let IconComponent = MdShoppingBag;
        let color = "#4A4B4A";
        let bgColor = "#F5F5F5";

        if (tipo === "COMPRA") {
            IconComponent = MdShoppingBag;
        }
        else if (isPayment || isCredit || tipo === "ESTORNO" || tipo === "DESCONTO") {
            IconComponent = MdAttachMoney;
            color = "#0BB07B";
            bgColor = "#E6F7F1";
        }
        else if (tipo === "ENCARGOS" || tipo === "TARIFA" || tipo === "ANUIDADE") {
            IconComponent = MdMoneyOff;
            color = "#E71037";
            bgColor = "#FDE8EC";
        }

        return { IconComponent, color, bgColor };
    };

    return (
        <Layout auth={false}>
            <Content>
                <img src={themes.components.images.logoTeuCard} alt="Logo TeuCard" />
                <Title>
                    Detalhamento de fatura
                </Title>

                <Header>
                    <S.BackButton onClick={() => history.goBack()}>
                        ← Voltar
                    </S.BackButton>
                </Header>

                <S.InvoiceTableWrapper>
                    <S.TableHeader>
                        <S.HeaderCell flex={1.2}>DATA</S.HeaderCell>
                        <S.HeaderCell flex={3}>DESCRIÇÃO</S.HeaderCell>
                        <S.HeaderCell flex={1.2} align="right">
                            VALOR
                        </S.HeaderCell>
                    </S.TableHeader>

                    <S.TableBody>

                        {data.lancamentos?.map((item, index) => {
                            const { IconComponent, color, bgColor } = getIconConfig(item);

                            return (
                                <S.TableRow key={item.idTransacao} odd={index % 2 === 0}>

                                    <S.TableCell flex={1.2}>
                                        <S.DateBlock>
                                            <S.DateMain>{item.dataFormatada}</S.DateMain>
                                            <S.DateSub>
                                                {isMobile
                                                    ? item.diaDaSemana?.split("-")[0]
                                                    : item.diaDaSemana}
                                            </S.DateSub>
                                        </S.DateBlock>
                                    </S.TableCell>

                                    <S.TableCell flex={3}>
                                        <S.DescriptionBlock>
                                            <S.IconWrapper style={{ backgroundColor: bgColor }}>
                                                <IconComponent size={16} color={color} />
                                            </S.IconWrapper>

                                            <S.DescriptionContent>
                                                <S.EstablishmentName>
                                                    {item.estabelecimento}
                                                </S.EstablishmentName>

                                                <S.EstablishmentDetail>
                                                    {item.descricao}
                                                    {item.quantidadeParcelas > 1 &&
                                                        ` ${item.parcelaAtual}/${item.quantidadeParcelas}`}
                                                </S.EstablishmentDetail>
                                            </S.DescriptionContent>
                                        </S.DescriptionBlock>
                                    </S.TableCell>

                                    <S.TableCell flex={1.2} align="right">
                                        <S.ValueText
                                            style={{
                                                color: item.debitoCredito === "CREDITO" ? "green" : "red",
                                            }}
                                        >
                                            {item.debitoCredito === "CREDITO" ? "+" : "-"}
                                            {moneyMask(item.valor)}
                                        </S.ValueText>
                                    </S.TableCell>

                                </S.TableRow>
                            );
                        })}

                    </S.TableBody>

                    <S.InvoiceFooter>
                        <S.FooterTop>
                            <S.FooterTopLabel>Total da fatura</S.FooterTopLabel>
                            <S.FooterTopValue>
                                {moneyMask(data.saldoFaturaAtual)}
                            </S.FooterTopValue>
                        </S.FooterTop>

                        <S.FooterDivider />

                        <S.FooterBottom>
                            <S.FooterInfoItem>
                                <S.FooterInfoLabel>Vencimento</S.FooterInfoLabel>
                                <S.FooterInfoValue>
                                    {convertISODateMode3(data.dataVencimento)}
                                </S.FooterInfoValue>
                            </S.FooterInfoItem>

                            <S.FooterInfoItem>
                                <S.FooterInfoLabel>Valor mínimo</S.FooterInfoLabel>
                                <S.FooterInfoValue>
                                    {moneyMask(data.valorMinimoRecebido)}
                                </S.FooterInfoValue>
                            </S.FooterInfoItem>

                            <S.FooterInfoItem>
                                <S.FooterInfoLabel>Status</S.FooterInfoLabel>
                                <S.FooterInfoValue>{data.status}</S.FooterInfoValue>
                            </S.FooterInfoItem>
                        </S.FooterBottom>
                    </S.InvoiceFooter>
                </S.InvoiceTableWrapper>

            </Content>
        </Layout>
    )
}

export default DetailingInvoice;